var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-right",class:{ 'mobile': _vm.isMobile }},[_c('pre',[_vm._v("©2020 Wen-Chi n g   Ye  n   Portfolio")])])}
var staticRenderFns = []

export { render, staticRenderFns }